export default {
  'register-invoiced': 'Register billing information',
  'assign-products': 'Assign inspector',
  'request-inspection': 'Request inspection on site for this petition',
  'assign-out-of-customs-date': 'Assign customs clearance date',
  'upload-paid-petition': 'Upload paid petition',
  'validate-products': 'Validate/cancelate productos to S.E.',
  'edit-service': 'Edit service'
};
